var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto content-personal",attrs:{"max-width":"80%"}},[_c('user-policy')],1)}
var staticRenderFns = []

export { render, staticRenderFns }